import {streamStore, tableStore, configStore, userStore, gamesStore} from 'app/store/global';
import {currentTimeStore} from 'stores/global';
import $ from 'jquery';
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import I18n from './i18n';
import createReactClass from 'create-react-class';
import Cookies from 'js-cookie';
import {modalAlert} from './utils/modals/popups';
import {hideLastPopup, showPopup} from 'app/utils/modals/ModalsService';
import {Store} from './store';
import {dateFormat} from './common';
import {getLinkPath, goToRoute} from 'app/utils/link_helper';
import round from 'lodash/round';
import httpFetch from 'app/utils/httpFetch';
import {isDesktop} from 'app/utils/windowFunctions';
import {ELEMENT_NOT_FOUND} from 'app/utils/Consts';
import {toastError} from './components/toasts/liteToast';
import SmartLoader from 'app/components/reusable/SmartLoader';
import {navigateGoTo} from './utils/navigate/navigateGoTo';
import {locationQuery} from 'app/utils/navigate/location';
import {LoaderPopup} from 'app/utils/modals/LoaderPopup';
import SpriteIcon from './utils/sprites/SpriteIcon';

const SECONDS_IN_MINUTES = 60;
const FIFTEEN_MINUTES = 15;

export {amountWithSign} from './utils/format';
export {fixed2, fixed3, fixed8} from './utils/fixed';
export {isString} from 'app/utils/type_helper';
export {parameterize} from 'app/utils/link_helper';
export {iOSDevice, isDesktop, isDesktopMedia, isDesktopSmall} from 'app/utils/windowFunctions';

export const HardRedirect = ({to}) => {
    useEffect(() => window.location.replace(to), [to]);
    return null;
};

export const saveTradeLinkHandler = function(tradeLink, ajaxAttrs) {
    return $.ajax('/user/update_trade_link', {
        data: {user: {trade_link: tradeLink}},
        dataType: 'JSON',
        type: 'POST',
        ...ajaxAttrs
    });
};

export const getMomentTime = function(timestamp) {
    return moment.unix(timestamp).tz(userStore.user.time_zone.full_name);
};

export const upToMinutes = (date, MINUTES) => {
    const future = moment(date).add(MINUTES, 'minutes');
    const now = moment();
    const minutes = future.diff(now, 'minutes');
    return {
        minutes,
        seconds: future.diff(now, 'seconds') - SECONDS_IN_MINUTES * minutes
    };
};

export const remainingTimeUntil15Minutes = date => {
    const future = moment(date).add(FIFTEEN_MINUTES, 'minutes');
    const now = moment();
    return Boolean(future.diff(now, 'seconds') > 0);
};

export const localDateTimeFromISO = function(val) {
    return moment(val).tz(userStore.user.time_zone.full_name).format('DD.MM.YYYY HH:mm:ss');
};

export const localDateFromISO = function(val) {
    return moment(val).tz(userStore.user.time_zone.full_name).format('DD.MM.YYYY');
};

export const localDateTimeFromISO8601 = function(val) {
    return moment(val).tz(userStore.user.time_zone.full_name).format('YYYY-MM-DDTHH:mm:ssZ');
};

export const localDateTimeTzFromISO = function(val) {
    return moment(val).tz(userStore.user.time_zone.full_name).format('DD.MM.YYYY HH:mm:ss z');
};

export const shortLocalDateTimeFromISO = function(val) {
    return moment(val).tz(userStore.user.time_zone.full_name).format('DD.MM HH:mm');
};

export const getMomentDiffMinutes = function(val) {
    return moment.duration(getMomentTime(val).diff(moment())).asMinutes();
};

export const timeStampToTime = function(timestamp, withTime) {
    return getMomentTime(timestamp).format(`DD.MM.YYYY${withTime ? ' HH:mm:ss' : ''}`);
};

export const timeStampToDashDate = function(timestamp) {
    return getMomentTime(timestamp).format('DD-MM-YYYY');
};

export const timeStampToTimeShortFormat = function(timestamp) {
    return getMomentTime(timestamp).format('DD.MM HH:mm');
};

export const secondsToShortHoursFormat = function(seconds) {
    const duration = moment.duration(seconds, 'seconds');
    const days = Math.floor(duration.asDays());
    const formatted = moment
        .utc(duration.asMilliseconds())
        .format(`H[${I18n.t('hours_short')}] m[${I18n.t('minutes_short')}]`);

    if (days > 0) {
        return `${days}${I18n.t('days_short')} ${formatted}`;
    }

    if (formatted === `0${I18n.t('hours_short')} 0${I18n.t('minutes_short')}`) {
        return '<1m';
    }

    return formatted;
};

export const timeStampToISODateFormat = function(timestamp) {
    return getMomentTime(timestamp).format('YYYY-MM-DD');
};

export const timeStampToISODateTimeFormat = function(timestamp) {
    return getMomentTime(timestamp).format('YYYY-MM-DDTHH:mm:ss');
};

export const momentObj = function(timestamp) {
    return moment.unix(timestamp).utc();
};

// TODO: remove it, use TimeToStartTimer;
export const TimeToStartTimerOld = props => {
    const momentObj = moment.unix(props.time_to_start).utc();

    return <span className="match-details__item-timer">
        {I18n.t('days', {count: momentObj.format('D') - 1})}
        <div className="match-details__item-time-left">{momentObj.format('HH:mm:ss')}</div>
    </span>;
};

export function localePromoName() {
    switch (window.location.pathname.match(/\/promo\/(.*)\//i)[1]) {
    case 'berlinmajor':
        return 'enigma';
    default:
        return 'ti8';
    }
}

export function promoUrl(path) {
    return `${window.location.pathname.match(/(.*)\//i)[0]}${path}`;
}

export const time = ts => dateFormat(ts, 'time', userStore.user.time_zone.int);

export const date = ts => dateFormat(ts, 'date', userStore.user.time_zone.int);

export const checkElement = (element, callback) => {
    if (!element) {
        return;
    }
    let e = element;
    if (typeof e === 'string') {
        [e] = e.split(',');
    }
    if ($(e).length > 0) {
        callback(e);
    }
};

export const scroll = element => {
    checkElement(element, e => $('html, body').animate({scrollTop: $(e).offset().top}, 'fast'));
};

export const scrollToElement = element => {
    checkElement(element, e => {
        $(e)[0].scrollIntoView();
        window.scrollBy(0, -$('.header').outerHeight());
    });
};

export const scrollToTop = () => {
    const [wrapperContent] = $('#react-content');

    if (wrapperContent) {
        wrapperContent.scrollIntoView();
    }
    $(window).scrollTop(0, 0);
};

export const closeMobileMenu = e => {
    if (isDesktop() || !e || !e.target) {
        return;
    }

    $(e.target).closest('.js-mobileMenu-container').prev().trigger('click');
};

export const closeMenuAndScrollToTop = e => {
    scrollToTop();
    closeMobileMenu(e);
};

export const scrollToBottom = () => $(window).scrollTop($(document).height());

export function updateTitle(title) {
    if (title) {
        document.title = title;
    }
}

export function updateMeta(meta) {
    ['keywords', 'description'].forEach(key => $(`meta[name="${key}"]`).attr('content', meta[key]));
}

export function placeCaretAtEnd(element) {
    element.focus();
    if (typeof window.getSelection !== 'undefined' && typeof document.createRange !== 'undefined') {
        const range = document.createRange();
        range.selectNodeContents(element);
        range.collapse(false);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (typeof document.body.createTextRange !== 'undefined') {
        const textRange = document.body.createTextRange();
        textRange.moveToElementText(element);
        textRange.collapse(false);
        textRange.select();
    }
}

export const mobileAndTabletCheck = function() {
    let check = false;
    (a => {
        if ((/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i).test(a) || (/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i).test(a.substr(0, 4))) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

export const checkingPages = {
    path() {
        return location.pathname;
    },
    isPlayPage() {
        return this.path().search(/play/i) !== -1;
    },
    isHomePage() {
        return this.path().search(/^\/[a-z]{0,2}\/?$/) !== -1;
    },
    isESportPage() {
        return this.path().search(/esports/i) !== -1;
    },
    isChatMobilePage() {
        return this.path().search(/chat\/mobile/i) !== -1;
    }
};

export function contentOnly() {
    return locationQuery().only_content;
}

export function streamGameImage(gameName, unlessStreamList, className, popup) {
    // TODO: streamGameImage should find by stream.filter, but filter fill in only in a new admin
    const game = gamesStore.collection.filter(filter => filter.name === gameName)[0];

    if (game) {
        const gameImageTag = tableGameImage(game, className);

        if (unlessStreamList) {
            return gameImageTag || null;
        }
        return gameImageTag
            ? <span className={`stream-list${popup ? '--popup' : ''}__item-icon`}>
                {gameImageTag}
            </span>
            : null;
    }
}

export function streamFlagImage(flag, unlessStreamList, className, popup) {
    const flagImageTag = flagImage(flag, className);

    if (unlessStreamList) {
        return flagImageTag || null;
    }
    return flagImageTag ? <span className={`stream-list${popup ? '--popup' : ''}__item-country`}>{flagImageTag}</span> : null;
}

export function currentTime() {
    return currentTimeStore.t;
}

export function initPerfectScroll(element, params) {
    element ||= $('.js-custom-scroll');
    element.perfectScrollbar(params || {wheelPropagation: true});
}

export const getImageDomain = (substr = true) => {
    let str = configStore.isRuHost ? configStore.CONFIG?.img_domain_ru : configStore.CONFIG?.img_domain;
    str ||= '';

    return substr && str.substr(ELEMENT_NOT_FOUND) === '/' ? str.substr(0, str.length - 1) : str;
};

export const flagImage = (src, className = '') => {
    if (!src) {
        return null;
    }

    const url = src.indexOf(getImageDomain()) === ELEMENT_NOT_FOUND ? `${getImageDomain()}/flags/${src}.svg` : src;
    return src ? <img src={url} alt={src} title={src} className={className}/> : null;
};

export function imageTag(src, options = {}) {
    const _options = {title: '', alt: '', className: '', ...options};
    return src ? <img src={src} {..._options}/> : null;
}

export function raceImage(src, className) {
    if (src && src != 'no.png') {
        const _src = src.indexOf(getImageDomain()) !== -1 ? src : `${getImageDomain()}/races/${src}`;
        const title = src.replace('.png', '');
        return <img src={_src} alt={title} title={title} className={className}/>;
    }
    return null;
}

export function smileImage(src, className) {
    const _src = src.indexOf(getImageDomain()) !== -1 ? src : `${getImageDomain()}/smiles/${src}`;
    return src ? <img data-src={_src} className={`${className} lazyload`}/> : null;
}

export function tableGameImage(filter, className) {
    if (typeof filter !== 'object') {
        filter = getGame(filter);
    }
    return filter && filter.filter_image
        ? <img src={getImageDomain(false) + filter.filter_image} alt={filter.name} title={filter.name} className={className}/>
        : null;
}

// TODO cut filters from BetService
export const gameImage = (filterId, className) => {
    const game = getGame(filterId);
    return game && game.filter_image
        ? <img src={getImageDomain(false) + game.filter_image} alt={game.name} title={game.name} className={className}/>
        : null;
};

export function getGame(filter) {
    function findFilter(obj) {
        if (isNumeric(filter)) {
            return obj.hasOwnProperty('id') && obj.id == filter;
        }
        return obj.hasOwnProperty('name') && obj.name == filter;
    }
    return gamesStore.collection.filter(findFilter)[0];
}

function isNumeric(num) {
    return !isNaN(num);
}

export function accordionMobMenu(opener, container) {
    const config = {
        opener,
        container
    };

    function init(id) {
        config.opener.unbind('click');
        config.opener.on('click', toggleMobMenu);
        if (id) {
            open(id);
        }
    }

    function toggleMobMenu(callback, id) {
        const isFunc = typeof callback === 'function';
        const currentOpener = isFunc ? $(id || window.location.hash) : $(this);
        const currentContainer = currentOpener.siblings(config.container);

        if (currentContainer.is(':hidden')) {
            config.container.slideUp().removeClass('container-active');
            currentContainer.slideDown('done', isFunc ? callback : null).addClass('container-active');
            config.opener.removeClass('accordion-active');
            currentOpener.addClass('accordion-active');
            $('#app').addClass('scroll-lock');
        } else {
            currentContainer.slideUp().removeClass('container-active');
            currentOpener.removeClass('accordion-active');
            $('#app').removeClass('scroll-lock');
        }
    }

    function open(id) {
        const objId = `#${id}` || window.location.hash;

        if (objId) {
            toggleContainer(() => scroll(objId), objId);
        }
    }

    return {
        init,
        open
    };
}

export function passwordOpener() {
    const config = {
        btn: $('.js-password-btn'),
        container: $('.js-password-fields')
    };

    function init() {
        config.btn.unbind('click');
        config.btn.on('click', showContainer);
    }

    function showContainer() {
        config.container.toggle();
        config.btn.closest('.js-buttons-hide').toggle();
        return false;
    }

    return {
        init
    };
}

export function minimize() {
    const currentItem = $('.js-popup-collapse-minimize');
    currentItem.parents('.js-popup-collapse').addClass('popup-collapse--minimized');
    currentItem.height = currentItem.parents('.popup-collapse__wrap').outerHeight() + 2;
    currentItem.width = currentItem.parents('.popup-collapse__wrap').outerWidth() + 2;
    currentItem.parents('.js-popup-collapse').animate({
        height: currentItem.height,
        width: currentItem.width
    }, 'done', () => {
        currentItem.parents('.js-popup-collapse').height('auto');
    });
    $('body').css('overflow', 'visible');
}

export function maximize() {
    const currentItem = $('.js-popup-collapse-expand');
    currentItem.parents('.js-popup-collapse').animate({
        height: '100%',
        width: '100%'
    }, function() {
        $(this).removeClass('popup-collapse--minimized');
    });
    $('body').css('overflow', 'hidden');
}

export function betMoneyCurrency(playmoney, amount) {
    if (playmoney) {
        return `${amount} PM`;
    }

    return `$${amount}`;
}

export function betMoney(bet, amount, isInteger, noCurrency) {
    const precision = isInteger ? 0 : 2;

    amount = round(Number(bet.amount?.toString() || amount), precision).toFixed(precision);
    if (isNaN(amount)) {
        return 0;
    }
    amount = amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    if (noCurrency) {
        return amount;
    }
    return betMoneyCurrency(bet.playmoney, amount);
}

export const positive = amount => !isNaN(amount) && Number(amount) > 0;

export function flatten(list) {
    return list.reduce((a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), []);
}

export function faqButton(faqPath) {
    return <div className="faq-button">
        <a href={getLinkPath(faqPath || '/faq')} target="_blank" className="act faq-button__icon" rel="noreferrer">
            <SpriteIcon name="#svg-question" />
        </a>
    </div>;
}

export function showAllByFilters(filters) {
    let showAllFilters = true;
    filters.forEach(filter => {
        if (filter.val) {
            showAllFilters = false;
        }
    });
    return showAllFilters;
}

export function userSignedIn() {
    return Boolean(userStore.user.id);
}

export function isGuest() {
    return !userSignedIn();
}

export function clear_hash() {
    const scr = document.documentElement.scrollTop;
    const scr2 = document.body.scrollTop;
    window.location.hash = '';
    if (scr) {
        document.documentElement.scrollTop = scr;
    } else {
        document.body.scrollTop = scr2;
    }
}

export const SubmitButton = createReactClass({
    propTypes: {
        title: PropTypes.string.isRequired,
        okClick: PropTypes.func.isRequired,
        className: PropTypes.string,
        cancelClick: PropTypes.func,
        cancelText: PropTypes.string
    },
    getInitialState() {
        return {submitting: false};
    },
    updateState(submitting) {
        this.setState({submitting});
    },
    okClick(e) {
        e.preventDefault();
        this.updateState(true);
        this.props.okClick(this.updateState);
    },
    render() {
        return this.state.submitting ? <SmartLoader /> : this.buttons();
    },
    buttons() {
        return this.props.cancelClick
            ? <div className={this.props.className}>
                <button type="button"
                    className={`button-adaptive button-adaptive_bigger-one button-adaptive_gray${this.disabledClass()}`}
                    disabled={this.state.submitting}
                    onClick={this.props.cancelClick}>{this.props.cancelText || I18n.t('confirm_button_no')}</button>
                {this.okButton()}
            </div>
            : this.okButton();
    },
    okButton() {
        return <button ref={this.props.okBtnRef} type="button"
            className={`button-adaptive button-adaptive_bigger-one${this.disabledClass()}`}
            disabled={this.state.submitting}
            onClick={this.okClick}>{this.props.title}</button>;
    },
    disabledClass() {
        return this.state.submitting ? ' button-adaptive_disable' : '';
    }
});

export function round2Decimal(val) {
    return Math.round(val * 100) / 100;
}

export function doShowInformer(filterId) {
    const filter = getGame(filterId);
    return tableStore.showAllFilters || filter && filter.val;
}

export function showWarningMessage() {
    modalAlert(I18n.t('warning_disabled_country'), {okClick: () => $.ajax('/user/disabled_country', {type: 'POST'})});
}

export function checkElementCookies(cookieName, undefinedVal = true) {
    if (typeof Cookies.get(cookieName) === 'undefined') {
        return undefinedVal;
    }
    return Cookies.get(cookieName) === 'true';
}

export function setElementCookies(cookieName, value) {
    Cookies.set(cookieName, value || !checkElementCookies(cookieName), {expires: 365 * 5});
}

export const removeParam = param => {
    const {location} = window;
    const query = locationQuery();

    if (delete query[param]) {
        navigateGoTo(location.pathname, query);
    }
};

export {getLinkPath, goToRoute} from 'app/utils/link_helper';

export function getPromoLinkPath(path) {
    return getLinkPath(`/promo/${Store.compendiumUrl()}${path || ''}`);
}

export function scrollByHash() {
    const betId = Number(window.location.hash.substr(1));

    if (window.location.hash && !betId || streamStore.fullScreen) {
        scroll(window.location.hash);
    }
}

export function runZEIdentify() {
    window.zESettings = {
        webWidget: {
            answerBot: {suppress: true},
            chat: {suppress: true},
            contactForm: {suppress: true},
            helpCenter: {suppress: true},
            offset: {
                horizontal: '20px',
                mobile: {
                    horizontal: '20px',
                    vertical: '70px'
                },
                vertical: '70px'
            },
            talk: {suppress: true}
        }
    };
    window.zE(() => {
        if (userStore.user.name) {
            window.zE.identify({name: userStore.user.name, email: userStore.user.email});
        }
        $('.support__link').removeClass('support__disabled');
    });
}

export function promotionArticles(articles) {
    return filterArticles(articles, ['promotion']);
}
export function newsArticles(articles) {
    return filterArticles(articles, ['hidden_temple', 'news']);
}

function filterArticles(articles, filter) {
    return articles.filter(article => {
        const {article_type} = article;
        return filter.indexOf(article_type) !== -1;
    });
}

export function getAllFiltersFlag(filters) {
    return !filters.find(filter => filter.val);
}

export function openContainer(component, key) {
    const opened = !component.state.opened;
    const container = component.container || component.props.containerRef;

    if (opened) {
        component.setState({opened});
        $(container.current).slideDown();
    } else {
        $(container.current).slideUp('done', () => component.setState({opened}));
    }
    if (key) {
        setElementCookies(key, opened);
    }
}

export function isOpenedContainer(component) {
    return component.state.opened ? ' opener-active' : '';
}

export function slowConnectionAndError(xhr) {
    return slowConnection(xhr, true);
}

export function handleInvalidCSRFToken(xhr) {
    const {status, getResponseHeader} = xhr;

    const csrfToken = getResponseHeader('Csrf-Token');

    if (status === 422 && csrfToken) {
        const headers = {
            ...$.ajaxSetup().headers,
            'X-CSRF-Token': csrfToken
        };
        $.ajaxSetup({headers});

        httpFetch.headers = {'X-CSRF-Token': csrfToken};
    }
}

export function slowConnection(xhr, handleError, show_loading = true) {
    const popupId = 'loading-popup';
    xhr.done(() => {
        clearTimeout(slowTimeout);
        hideLastPopup(popupId);
    }).fail(xhr => {
        const {statusText} = xhr;

        handleInvalidCSRFToken(xhr);
        clearTimeout(slowTimeout);
        hideLastPopup(popupId);
        if (handleError && statusText !== 'abort') {
            serverError();
        }
    });
    const slowTimeout = setTimeout(() => {
        if (show_loading) {
            showPopup(popupId, props => <LoaderPopup popupId={props.popupId}/>);
        }
    }, 300);
    return xhr;
}

export const slowConnectionPromise = (promise, show_loading = true) => {
    const popupId = 'loading-popup';
    let slowTimeout = null;

    promise.finally(() => {
        clearTimeout(slowTimeout);
        hideLastPopup(popupId);
    });

    const SLOW_CONNECTION_TIME = 300;

    slowTimeout = setTimeout(() => {
        if (show_loading) {
            showPopup(popupId, props => <LoaderPopup popupId={props.popupId}/>);
        }
    }, SLOW_CONNECTION_TIME);
    return promise;
};

export function serverError(okClick) {
    modalAlert(I18n.t('server_error_try_later'), {okClick});
}

export const ajaxError = function(xhr) {
    const {responseJSON, status} = xhr;

    if (status === 422) {
        if (responseJSON) {
            toastError(Object.values(responseJSON)[0][0]);
        }
    } else {
        serverError();
    }
};

export function ajaxErrorAndHideConfirm(xhr) {
    ajaxError(xhr);
    hideLastPopup('modal-confirm');
}

$.extend({
    getUrlVars() {
        let vars = [],
            hash;
        const hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

        for (let i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    },
    getUrlVar(name) {
        return $.getUrlVars()[name];
    }
});
